
import ReactHtmlParser from 'html-react-parser';
import React, { useEffect, useRef, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { format } from 'react-string-format';
import usePageTitle from '../../Hooks/usePageTitle';
import useResize from '../../Hooks/useResize';
import '../../i18n';
import { APIGet, APIPost, getEnvironment } from '../API/APIRequest';
import { LoginInfo } from '../Authentication/Account/LoginInfo';
import { useAuth } from '../Authentication/AuthenticationProvider';
import { GuestUser } from '../Checkout/User/GuestUser';
import Button from '../UI/Buttons/Button';
import ErrorBox from '../UI/ErrorBox/ErrorBox';
import { GenericErrorBox } from '../UI/ErrorBox/GenericErrorBox';
import MessageBox from '../UI/MessageBox/MessageBox';
import Modal from '../UI/Modal/Modal';
import { getOriginatingUrl, getThankyouPageUrl } from '../Utilities/GetUrlFunctions';
import {  gtmEventTriggers } from '../Utilities/GtmFunctions';
import { Loading } from '../Utilities/Loading';
import { GetADToken, RefreshADToken } from '../Utilities/TokenManager';
import { LogWebActivity } from '../Webactivity/LogWebActivity';
import "./Payment.scss";
import { AutorenewalTerms } from './Payment/AutorenewalTerms';
import { Basket, GetBasket, ResetBasket, SaveToOrder, UpdateBasket } from './Payment/Basket';
import { computeUpdatedBasket } from './Payment/basketAddressReducer';
import { BillingDetails } from './Payment/BillingDetails';
import { DeliveryDetails } from './Payment/DeliveryDetails';
import { DirectDebitForm, UpdateDirectDebitPaymentRequest } from './Payment/DirectDebitForm';
import { Invoice, UpdateInvoicePaymentRequest } from './Payment/Invoice';
import { MarketingPreferences } from './Payment/MarketingPreferences';
import { PaymentSelection } from './Payment/PaymentSelection';
import { PaypalForm, UpdatePaypalPaymentRequest } from './Payment/PaypalForm';
import { checkForWalletMethods, InitialiseStripe, StripeForm, UpdateStripePaymentRequest } from './Payment/StripeForm';
import { WorldPayForm } from './Payment/WorldPayForm';
import { CapturePhone } from './Payment/CapturePhone';
import { accountNumberRegex, sortCodeRegex } from '../Utilities/EmailRegex';
import DiscountCode from './Payment/PromoCode';
import PromoCode from './Payment/PromoCode';
import { appendClientQueryParams, checkForPreviousAddresses, focusOnFirstError, loqateRequestLogs, splitName } from '../Utilities/Functions';
import { checkIsInvalid } from '../Utilities/FieldValidations';
import { OrderUpgrade } from './OrderUpgrade';
import ShimmerInput from '../UI/ShimmerInput/ShimmerInput';


export function Payment(props) {

 
    const { t, i18n } = useTranslation();
    //session delivery details for reinstating basket after a reload
    const sessionDeliveryDetails= JSON.parse(sessionStorage.getItem("sessionDeliveryDetails"));
    //discount code or discount flow indicative of discount flow
    const discountFlow = sessionStorage.getItem("discountApplied");
    const deliveryRef = useRef({});
    const billingRef = useRef({});
    const [returnUrl, setReturnUrl] = useState([]);
    const [errors, setErrors] = useState([]);
    const [basketErrors, setBasketErrors] = useState([]);
    const [paymentMethodErrors, setPaymentMethodErrors] = useState();
    const [loading, setLoading] = useState(true);
    const [basket, setBasket] = useState({});
    const latestBasketRef = useRef({});

    const basketUpdateSeq = useRef(0);
    const basketUpdatesInFlight = useRef(0);
    const [vatNo, setVatNo] = useState("");
    const [billingAddress, setBillingAddress] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [deliveryAddress, setDeliveryAddress] = useState({})
    const [billingCompany, setBillingCompany] = useState({})
    const [deliveryCompany, setDeliveryCompany] = useState({})
    const [billingLoadingState, setBillingLoadingState]=useState()  //for delivery form submission animation
    const [companyList, setCompanyList] = useState([]);
    const [paymentSelection, setPaymentSelection] = useState({ paymenttype: null, updatepaymentrequestfunction: null });
    const [wpHostedURL, setWpHostedURL] = useState(null)
    const [IsFilledBilling, setIsFilledBilling] = useState({});
    const [isInvalidBilling, setIsInvalidBilling] = useState({});
    const [IsFilledDelivery, setIsFilledDelivery] = useState({});
    const [isInvalidDelivery, setIsInvalidDelivery] = useState({});    
    const [billingsSameCheck, setBillingsSameCheck] = useState(false) 
    const [giftRecipientDetails , setGiftRecipientDetails] = useState({})   
    const [vatDetails , setVatDetails] = useState({})
    const [showCompany , setShowCompany] = useState({})
    const [errorStates, setErrorStates] = useState({noPaymentSelected:false, cardHolderNameBlank: false, cardDeclined:false, autoRenewalNotTicked:false, authDD: false, isBlankAccountNameDD: false, isBlankBankDD:false, invalidAccountNumberDD:false, invalidSortCodeDD:false, invalidFormatAccountNumberDD:false, invalidFormatSortCodeDD:false, isBlankAccountNumberDD:false, isBlankSortCodeDD:false, isVatEmpty: false, stripeCardIsInvalid: false});
    const [IsAutoRenewalChecked, setIsAutoRenewalChecked] = useState(false);
    const [IsAuthDebitCardChecked, setIsAuthDebitCardChecked] = useState(false);
    const [IsMarketingPreferencesChecked, setIsMarketingPreferencesChecked] = useState(false);
    const [isPaypal, setIsPaypal] = useState(false);
    const [IsContinuousMethodPresent, setIsContinuousMethodPresent] = useState(false);
    const paymentConfirmRef = useRef(null);
    const [sectionComplete, setSectionComplete] = useState({});
    const [recipientDetails, setRecipientDetails] = useState({firstName:"", lastName: "", userEmail: ""} );
    const [deliveryCountryCode, setDeliveryCountryCode] = useState("")
    const [billingCountryCode, setBillingCountryCode]=useState("");
    const [initialFilledState, setInitialFilledState]=useState({});
    const location = useLocation()
    const [deliveryAddressStructure, setDeliveryAddressStructure] = useState([]);
    const [companyProperties, setCompanyProperties] = useState({});
    const adToken = GetADToken();
    const [guestSession, setGuestSession] = useState(location.state ? location.state.guestSession : adToken?.isGuest ? adToken :"");
    const params = new URLSearchParams(window.location.search);
    const discountRemoved= params.get("discountRemoved"); 
    const purchasingFor= params.get("purchasingFor");
    const isGuest = props.guest;
    const [flags, setFlags] = useState({  });
    const auth = useAuth();
    const [ locationKeys, setLocationKeys ] = useState([])
    const [oAuthentication, setOAuthentication] = useState(null);
    const [showModal, setShowModal] = useState(false)
    const [isMobile, setIsMobile] = useState(false);
    const [isDirectDebit, setIsDirectDebit] = useState(false);
    const [variantIdCsvSMO, setVariantIdCsvSMO] = useState("");
    const [variantIdCsvPR, setVariantIdCsvPR] = useState("");
    const [variantIdForPromoCode, setVariantIdForPromoCode] = useState("");
    const frontendConfiguration=JSON.parse(sessionStorage.getItem("FrontendConfig"))
    const [loqateKey, setLoqateKey] = useState(frontendConfiguration?.loqateAPIKey ?? "");
    const [checkVariantCardPaymentBrand, setCheckVariantCardPaymentBrand] = useState(frontendConfiguration?.checkVariantCardPaymentBrand ?? "");
    const [BankVerificationAPIKey, setBankVerificationAPIKey] = useState(frontendConfiguration?.loqateBankVerificationAPIKey ?? "");
    const [BankConfiguration, setBankConfiguration] = useState(frontendConfiguration?.enableLoqateBankVerification ?? ""); 
    const [enableWallets, setEnableWallets] = useState(frontendConfiguration?.enableStripeWallets ?? "");
    const [showAutoRenewalConsentCheckbox, setShowAutoRenewalConsentCheckbox] = useState(frontendConfiguration?.showAutoRenewalConsentCheckbox !== false);
    const [showWorldPay, setShowWorldPay] = useState(false);
    const [alreadyPurchased, setAlreadyPurchased]=useState({"status":"","text":""});
    const [purchaseRestriction, setPurchaseRestriction]=useState({"status":"","text":""});
    const environment = getEnvironment();
    const [showError, setShowError] = useState(false);
    const [creditCardHolderName, setCreditCardHolderName] = useState("");
    const {setFid, metaData} = props;
    const errorContainerRef= useRef(null);
    usePageTitle(`Checkout -  ${props.brandingElement?.id}`);
    let windowSize = useResize();
    const { fid } = useParams();
    const [ddDetails, setddDetails] = useState({accountholder:"", bankname:"", accountnumber:"", sortcode:""});
    const [BankValidation, setBankValidation] = useState([]);
    const [phoneConfiguration, setphoneConfiguration] = useState(); 
    const [phoneNumber, setPhoneNumber] = useState(""); 
    const [isPhoneNumberBlank, setIsPhoneNumberBlank] = useState(false); 
    const [isPhoneNumberInvalid, setIsPhoneNumberInvalid] = useState(false); 
    const [actionName, setActionName] = useState("");
    const [optionalEmail, setOptionalEmail] = useState(true); 
    const [isVatChecked, setIsVatChecked] = useState(false);
    const [isVatApplied, setIsVatApplied] = useState(false);
    const [isDpaQuestionTextBlank, setIsDpaQuestionTextBlank] = useState("");
    const [checkoutStartedFired, setCheckoutStartedFired] = useState("");
    const [stripeMethodName, setStripeMethodName] = useState("");
    const availableWalletMethods = JSON.parse(sessionStorage.getItem("AvailableWalletMethods"))
    const [walletMethods, setWalletMethods] = useState(  availableWalletMethods  || "" );
   let stripeCreds = JSON.parse(sessionStorage.getItem("stripeData"));
    const [stripePublicKey, setStripePublicKey] = useState(stripeCreds?.publickey ?? "");
    const [stripeCredentials, setStripeCredentials] = useState(stripeCreds ?? "")
    const stripeAdditionalPaymentTypesConfig = sessionStorage.getItem("stripeAdditionalPaymentTypes")
    const [stripeAdditionalPaymentTypes, setStripeAdditionalPaymentTypes] = useState( stripeAdditionalPaymentTypesConfig ? stripeAdditionalPaymentTypesConfig : "");
    const [paymentElementReload, setPaymentElementReload] = useState(false);
    const phoneRef = useRef(null);
    const [billingSectionLoading, setBillingSectionLoading] = useState(false);
    const [groupDiscountNotValid, setGroupDiscountNotValid] = useState({status:"", errorText:""});
    const [groupDiscountFlow, setGroupDiscountFlow] = useState("");

    const [latestBillingDetails, setLatestBillingDetails] = useState();
    //if delivery details are present in session so no need to fetch from lastest addresses
    const [usingLatestDeliveryDetails, setUsingLatestDeliveryDetails] = useState(!sessionDeliveryDetails); // to check if latest delivery details are being used to prefill the form
    const [usingLatestBillingDetails, setUsingLatestBillingDetails] = useState(true); // to check if latest billing details are being used to prefill the form
    const [latestDeliveryDetails, setLatestDeliveryDetails] = useState();
    const [promoCode, setPromoCode] = useState("");

    let navigate=useNavigate();

   
    //***********************************basket methods begin***********************************/

    
    useEffect(() => {
        
        if (basketUpdatesInFlight.current === 0) {
            latestBasketRef.current = basket;
        }
    }, [basket]);

    // Decides synchronously (at basket-load time) whether the latest-address flow
    // will run its own basket init. When it will, the mount-time "resetting" call
    // is unnecessary and must be skipped, otherwise the two clash and GetBasket
    // reloads stale/wrong data.
    //
    // A LatestAddress instance runs latestAddressInit only when:
    //   - the user has saved locations (a token is present), AND
    //   - an address section that consumes them will render:
    //       delivery latest  -> isdeliverypostaladdressrequired || allowgifting
    //       billing  latest  -> collectbillingaddress


    const willLatestAddressInitRun = (loadedBasket) => {

     //for discount we need to update with session delivery details so skipping latest address init
        if (discountFlow) return false;

        const adToken = GetADToken();
        const hasToken = Boolean(adToken?.token);
        if (!hasToken) return false;

        let hasLatestForFid = false;
        try {
            const cached = JSON.parse(sessionStorage.getItem("latestAddresses"));
            hasLatestForFid = Boolean(cached && cached.fid === fid && (cached.delivery || cached.billing));
        } catch (_) {
            hasLatestForFid = false;
        }
        if (!hasLatestForFid) return false;

        const deliveryLatestPossible =
            !sessionDeliveryDetails &&
            Boolean(loadedBasket?.isdeliverypostaladdressrequired || loadedBasket?.allowgifting);

        const billingLatestPossible = Boolean(loadedBasket?.collectbillingaddress);

        return deliveryLatestPossible || billingLatestPossible;
    };

    const updateAndRefreshBasket = (countryCode, type, result, countyCode)=>{

        // Merge onto the explicitly provided basket if given, otherwise onto the
        // freshest known basket (ref) rather than the stale `basket` closure. This
        // prevents a concurrent refresh call from overwriting country/county values
        // just applied by another call (resetting vs latestAddressInit clash).

        const sourceBasket = result || latestBasketRef.current || basket;
        const updatedBasket = computeUpdatedBasket({
          sourceBasket,
          type,
          countryCode,
          countyCode,
          usingLatestBillingDetails,
          usingLatestDeliveryDetails,
          hasSessionDeliveryDetails: Boolean(sessionDeliveryDetails),
        });

        latestBasketRef.current = updatedBasket;

        // Claim this update as the newest. Any older update still in flight becomes
        // stale and its post-update refetch will be skipped below.
        const myToken = ++basketUpdateSeq.current;
        basketUpdatesInFlight.current += 1;

        UpdateBasket({ fid, setBasketErrors, basket: updatedBasket }).then((res)=>{

        // A newer update superseded this one — do not run its refetch, it would
        // overwrite the newer country/county with an older server snapshot.
        if (myToken !== basketUpdateSeq.current) return;

        if(!res){
                if (isGuest) { 
                    loadGuestBasket(purchasingFor || "unknown", true, false);}
                 else { 
                    loadBasket(purchasingFor || "unknown", true, false);
                }
            }}).catch((error)=>{

                // Still drop stale errors so an old failed update can't clobber a
                // newer successful one.
                if (myToken !== basketUpdateSeq.current) return;

                if (error.length && error.includes("error.basketcompletedorder")) {

                    // Handles the error related to a completed order

                    setBasketErrors(error);
                    setBasket({});
                } 
                else{
                    setBasketErrors(error);
                }
               }).finally(()=>{
                   basketUpdatesInFlight.current = Math.max(0, basketUpdatesInFlight.current - 1);
               })
             }


    // Continue past the "not eligible for discount" box.
    const continueWithoutDiscount = () => {
        const hasAppliedDiscount = basket?.lines?.some(l => l.groupdiscountcode);
        if (hasAppliedDiscount) {
            APIPost({
                "controller": "basket",
                "action": "removepromocode",
                "environment": null,
                "identifier": fid
            }).then((response) => {
                if (response?.status === 200 && response?.data?.success) {
                    updateAndRefreshBasket(deliveryCountryCode, "resetting", response.data.basket, basket?.destinationcountycode);
                }
                setGroupDiscountFlow("false");
            }).catch((error) => {
                console.error('Error:', error);
                setGroupDiscountFlow("false");
            });
        } else {
            setGroupDiscountFlow("false");
        }
    };

    const checkForRefreshADToken = async () => {

        let token = await RefreshADToken();
         
        if (token) {  
            //if token present session continues
            return;
        } else {

          //else redirection to landingPage  
          let url = '/checkout/' + fid + `?error=tokenExpired` ;
          navigate(url);
       }
    }

    useEffect(() => {
   
    if (!frontendConfiguration){
         getFrontendConfiguration();
        }   

    
    if (isGuest) { 
        loadGuestBasket(purchasingFor || "unknown", false, true);}
    else { 
        loadBasket(purchasingFor || "unknown", false, true);}

   
        if(!isGuest){

            checkForRefreshADToken(); // first call on mount

            const interval = setInterval(() => {
                checkForRefreshADToken(); // checking every minute
            }, 60000);
     
            return () => clearInterval(interval); 

        }

    }, [])


    useEffect(()=>{
    
    //when basket is ineligible for availing discount
     if(props?.brandingElement){
        setGroupDiscountNotValid(groupDiscountNotValid => ({...groupDiscountNotValid, errorText: props.brandingElement?.discountIneligible}));
     }

    }, [props.brandingElement])

    const getStripeConfiguration=()=>{
        
        APIGet({
            "controller": "configuration",
            "action": "stripeconfiguration",
            "environment": environment,
       
        }).then((response)=>{
           let additionalPaymentMethodTypes = response.data?.configuration?.additionalPaymentMethodTypes
           setStripeAdditionalPaymentTypes(additionalPaymentMethodTypes);
           sessionStorage.setItem("stripeAdditionalPaymentTypes", additionalPaymentMethodTypes)
        
        }).catch((error)=>{
           console.log(error, "Error occured in getting stripe configuration")
        })
    }
    
    const checkForStripeMethod=(basket)=>{
        
        let paymentTypes=basket?.paymentTypes;

        paymentTypes.find((paymentType)=>{
            
         if((paymentType?.name==="Creditdebitcard" || paymentType?.name==="Continuouscreditdebitcard")  && basket?.defaultpaymentprovider==="stripe"){
            let userToken = GetADToken();
            if (userToken?.partyid > 0) {
                
               if(!stripeAdditionalPaymentTypesConfig){
                getStripeConfiguration();
              }
                
                handleInitializePayment(paymentType, basket);
            }

         }})

    }



    const loadGuestBasket = (purchaseTarget, forcedRefresh, resettingCountryOnMounting) => {
      
        if (!fid && basket?.id) {
            fid = basket.id;
        }

           
       if (!auth?.userData) {
            auth.ReloadUserData();
        }
    
      let guestToken = location?.state?.guestUser.token || auth?.userData?.token     

        
     GetBasket({ "fid": fid, "loadfromserver": true, "userToken": guestToken , "purchaseTarget": purchaseTarget, }).then((result) => {
        
               //adding guest user party Id to the guest basket data,
               result = { ...result, partyid: location.state ? location.state.guestUser.partyid : 0}

               if(result?.infomessages.includes("info.discountineligible")) {
                    
                  setGroupDiscountNotValid(groupDiscountNotValid => ({...groupDiscountNotValid, status:"true"}));
                  setGroupDiscountFlow("true");

                }

               //skip restting as the updates will be covered by update basket type - latestaddressInit
                if(resettingCountryOnMounting && !willLatestAddressInitRun(result)) {

                    if(discountFlow){

                        //updating destination country code in discounted basket with prev baskets for successful vat application
                        let countryCode = sessionStorage.getItem("prevDeliveryCountryCode");
                        let countyCode = sessionStorage.getItem("prevDeliveryCountyCode");
                        updateAndRefreshBasket(countryCode, "resetting", result, countyCode);

                    }else{

                        if(sessionDeliveryDetails){
                            let countryCode=sessionDeliveryDetails?.countryCode;
                            let countyCode=sessionDeliveryDetails?.countyCode;
                            updateAndRefreshBasket(countryCode, "resetting", result, countyCode)

                        }
                       
                    }
                }
                
                  //for vat in discountflow

                setBasket(result); //guestBasket
              
               
                if(!forcedRefresh){
                    checkForStripeMethod(result);
                }else{
                    setBillingSectionLoading(false)
                }
                
                //first time or if the country changes and if not forced update as for that a call is already present

                 if ((!deliveryCountryCode || result.countrycode !== deliveryCountryCode) && !forcedRefresh)
                 {

                     if (discountFlow)
                     {
                        let countryCode = sessionStorage.getItem("prevDeliveryCountryCode")    //overriding discounted basket's country code with prev basket's
                        getAddressStructure(countryCode, fid)  //to be run just once
                        setDeliveryCountryCode(countryCode)
                        getDeliveryCountryForGuestFlow(result?.countries, countryCode);  
                    } 
                    else
                    {
                          let countryCode = sessionDeliveryDetails?.countryCode
                          if(countryCode){
                                getAddressStructure(countryCode, fid)  
                                setDeliveryCountryCode(countryCode)
                                getDeliveryCountryForGuestFlow(result?.countries, countryCode);  
                          }
                          else
                          {
                                getAddressStructure(result.countrycode, fid)  
                                setDeliveryCountryCode(result.countrycode)

                              getDeliveryCountryForGuestFlow(result?.countries, result?.countrycode);   
                          }
                                           
                    }
                             
                }

                //in case we have an already logged in user going through guest flow 
                if(isGuest && !guestSession ){
                    let loggedInUser=GetADToken();

                    if(loggedInUser && !loggedInUser?.isGuest){
                        sessionStorage.setItem("loggedInUserEmail", loggedInUser?.username)
                    }

                }

                //In gift flows check will be at gift recipient level  
                if(guestSession && !result.allowgifting && !forcedRefresh){
                    let guestToken= GetADToken();
                    checkForBasketRestrictions(guestToken.partyid, guestToken.username, result);
                   
                }

                
                setFlags({ ...flags, isdeliverycountryrequired: result.isdeliverycountryrequired, isdeliverypostaladdressrequired: result.isdeliverypostaladdressrequired, collectbillingaddress: result.collectbillingaddress })
                CheckIsContinuousMethodPresent(result);
                setVatDetails({"showTaxCode":result.canapplytaxcode, "taxCodeFormat":result.taxcodeformat})
                setShowCompany(!result.hidecompanyoncheckout);
                 
                 //session Delivery Details restoring settings on reload
               
                

                if(sessionDeliveryDetails && sessionDeliveryDetails !== "undefined" && resettingCountryOnMounting){
                   
                    showSavedDeliveryDetails(sessionDeliveryDetails);
                }
              
                if(!discountFlow){
                    sessionStorage.setItem("originatingUrl", result.originatingurl)   //In discount flow overriding discounted basket's originatingUrl (incorrect) with original basket's
                }

              
                if (!fid) {
                    var newPath = window.location.protocol + "//" + window.location.host;
                    if (window.location.pathname) {
                        newPath += window.location.pathname;
                    }
                    newPath += result.id;
                    window.history.pushState({ path: newPath }, '', newPath);

                }
               
                // if (result.allowgifting && result.allowindividualcheckout){
                //     setPopUpFlow(true)
                //     if(!purchasingFor){
                //     setShowPopup(true);
                //     }
                // }
                // else{
                //     setPopUpFlow(false)
                // }  for later
            
                
        }).catch((errors) => {
            setBasketErrors(errors);
            setReturnUrl(errors?.originatingurl)
            setLoading(false);
        });
        
    }


    const loadBasket = (purchaseTarget,forcedRefresh, resettingCountryOnMounting) => {

     
      if (loading || forcedRefresh) {
            GetBasket({ "fid": fid, "loadfromserver": true, "userToken": auth?.userData?.token, "purchaseTarget":purchaseTarget }).then((result) => {
                

                if(result?.infomessages.includes("info.discountineligible")) {
                    
                    setGroupDiscountNotValid(groupDiscountNotValid => ({...groupDiscountNotValid, status:"true"}));
                    setGroupDiscountFlow("true");

                 }
  
            

                //skip restting as the updates will be covered by update basket type - latestaddressInit
                if(resettingCountryOnMounting && !willLatestAddressInitRun(result)) {

                    if(discountFlow){

                        //updating destination country code in discounted basket with prev baskets for successful vat application
                        let countryCode = sessionStorage.getItem("prevDeliveryCountryCode");
                        let countyCode = sessionStorage.getItem("prevDeliveryCountyCode");
                        updateAndRefreshBasket(countryCode, "resetting", result, countyCode)

                    }else{

                        if(sessionDeliveryDetails){
                            let countryCode=sessionDeliveryDetails?.countryCode;
                            let countyCode=sessionDeliveryDetails?.countyCode;
                            updateAndRefreshBasket(countryCode, "resetting", result, countyCode)

                        }
                        

                     }
                }

                setBasket(result);
                
                if(!forcedRefresh){
                    checkForStripeMethod(result);
                }else{
                    setBillingSectionLoading(false)
                    }
                
                
                if((!deliveryCountryCode || result.countrycode !== deliveryCountryCode) && !forcedRefresh){
                    
                    if (discountFlow)
                    {
                       let countryCode = sessionStorage.getItem("prevDeliveryCountryCode")    //overriding discounted basket's country code with prev basket's
                       getAddressStructure(countryCode, fid)  //to be run just once
                       setDeliveryCountryCode(countryCode)
                    } 
                   else
                   {
                         let countryCode = sessionDeliveryDetails?.countryCode
                         if(countryCode){
                               getAddressStructure(countryCode, fid)  
                               setDeliveryCountryCode(countryCode)
                              
                         }
                         else
                         {
                               getAddressStructure(result.countrycode, fid)  
                               setDeliveryCountryCode(result?.countrycode)

                          }}
                 }

                if(!result.allowgifting && !forcedRefresh){
                    let userToken= GetADToken();
                    checkForBasketRestrictions(userToken?.partyid, userToken.username, result);  //stop multiple orders when enabled

                }

                
                setFlags({ ...flags, isdeliverycountryrequired: result.isdeliverycountryrequired, isdeliverypostaladdressrequired: result.isdeliverypostaladdressrequired, collectbillingaddress: result.collectbillingaddress })
               
                setVatDetails({ "showTaxCode": result.canapplytaxcode, "taxCodeFormat": result.taxcodeformat })

                 //session Delivery Details restoring ssettings on reload

             
               if(sessionDeliveryDetails && sessionDeliveryDetails !== "undefined" && resettingCountryOnMounting){
                    showSavedDeliveryDetails(sessionDeliveryDetails);
                }

                CheckIsContinuousMethodPresent(result);
                setShowCompany(!result.hidecompanyoncheckout);

                if(!discountFlow){
                sessionStorage.setItem("originatingUrl", result.originatingurl);
                }
              
               
             
            }).catch((errors) => {
                setBasketErrors(errors);
                setReturnUrl(errors.originatingurl)
                setLoading(false);
            });
        }
    }
    

    
     useEffect(()=>{
         if (!isGuest || (isGuest && !guestSession)){
            setFid(fid); //to pass to metadata extraction
        }
    },[fid])

    const getDeliveryCountryForGuestFlow =(countryList, countryCode)=>{
        if (countryList && countryCode) {
            let country= countryList?.find(t => t.countrycode === countryCode)
         
            if(country){
             setDeliveryAddress(deliveryAddress=>({...deliveryAddress, "COUNTRY": country?.countryname}));
            }
             else{
             setDeliveryAddress(deliveryAddress=>({...deliveryAddress, "COUNTRY": countryList[0]?.countryname}));   
                
             }
    }}
    
    //purchase restriction Stop Multiple Orders
    const checkForAlreadyPurchased=(partyid, username, csvForSMO, csvForPR, changeorderurl)=>{

       APIGet({
            "controller": "order",
            "action": "hasvariantorders",
            "identifier": partyid,
            "environment": environment,
            "data" : {"variantIdcsv": csvForSMO} 
       
        }).then((response) => {
            if(response.data.hasorders){
               let alreadyPurchasedText= format(t('error.alreadypurchased'), username, changeorderurl )
               setAlreadyPurchased({"status":"true", "text": alreadyPurchasedText}); // in case- any present variant already has been purchased

               const checkoutStarted = sessionStorage.getItem("CheckoutStarted");
               const adToken = GetADToken();

               if(checkoutStarted && adToken){
                setActionName("Checkout restricted")  } 
                } 
            else{
               setAlreadyPurchased({"status":"false", "text": ""}); 
               checkForPurchaseRestriction(partyid , username , csvForPR , changeorderurl) 
            }
         }).catch(function (errors) {
             console.log(errors);
         })
    }
    
    //Purchase restriction BI filter
    const checkForPurchaseRestriction=(partyid, username, csvForPR, changeorderurl)=>{

       APIGet({
            "controller": "order",
            "action": "haspurchaserestriction",
            "identifier": partyid,
            "environment": environment,
            "data" : {"variantIdcsv": csvForPR} 
       
        }).then((response) => {
            if(response.data.restrictpurchase){
               let purchaseRestrictedText= format(t('error.bifilterrestriction'), username, changeorderurl )
               setPurchaseRestriction({"status":"true", "text": purchaseRestrictedText});  // in case- current variant has already been purchased

               const checkoutStarted = sessionStorage.getItem("CheckoutStarted");
               const adToken = GetADToken();

               if(checkoutStarted && adToken){
                setActionName("Checkout restricted")  } //checkout restricted web activity
                } 
            
            else{

               setPurchaseRestriction({"status":"false", "text": ""}); // going back to initial state
            }
          }).catch(function (errors) {
             console.log(errors);
          })
    }

    //for basket checks-- keep adding the checks here    
    const checkForBasketRestrictions=(partyId, userName, basketData)=>{

        let csvForSMO= getCSV(basketData, "SMO");
        let csvForPR= getCSV(basketData, "PR");
        let changeorderurl="";
        
        if(!discountFlow){
            changeorderurl= basketData.originatingurl || sessionStorage.getItem("originatingUrl");
        }
        else{
            changeorderurl = sessionStorage.getItem("originatingUrl");
        }

        if(csvForSMO){
             
           setAlreadyPurchased({ "status": "false", "text": "" }); // we have variants with SMO enabled so now changing status to false(assuming)
           checkForAlreadyPurchased(partyId, userName, csvForSMO, csvForPR, changeorderurl)
           
        }
        else{

          if(csvForPR){

           setPurchaseRestriction({ "status": "false", "text": "" }); // we have variants with Restrict Purchasing enabled so now changing status to false(assuming)
           checkForPurchaseRestriction(partyId, userName, csvForPR, changeorderurl)
           
        }
      }
    }
   
   //csv values
   const getCSV=(result, type)=>{
  
      let variantIdArraySMO=[];  //stop multiple order flag enabled
      let variantIdArrayPR=[];   //purchase restriction BI filter enabled

      if(result?.lines){
         result.lines.forEach((variant, id)=>{
          
            variantIdArrayPR.push(variant?.productvariantid)
            if (variant?.stopmultipleorders===true){
                variantIdArraySMO.push(variant?.productvariantid)
               }
            })
        }

        let idForPromoCode = variantIdArrayPR.join(",")
        setVariantIdForPromoCode(idForPromoCode) //single variant id for promo code

        if(type==="SMO"){
           let csvForSMO = variantIdArraySMO.join(",");
           setVariantIdCsvSMO(csvForSMO);
           return csvForSMO;
        }

        if(type==="PR"){
           let csvForPR = variantIdArrayPR.join(",");
           setVariantIdCsvPR(csvForPR);
           return csvForPR;
        }
    }

  
    
    //fetching frontend configurations
    const getFrontendConfiguration=()=>{
         APIGet({
            "controller": "configuration",
            "action": "frontendconfiguration",
            "environment": environment,
         }).then((response) => {
             let config= response.data.configuration

             sessionStorage.setItem("FrontendConfig", JSON.stringify(config) );
             setLoqateKey(config?.loqateAPIKey);
             setBankConfiguration(config?.enableLoqateBankVerification);
             setBankVerificationAPIKey(config?.loqateBankVerificationAPIKey)
             setCheckVariantCardPaymentBrand(config?.checkVariantCardPaymentBrand);
             setEnableWallets(config?.enableStripeWallets);
             // Only hide the consent checkbox when the config explicitly says false; absent/undefined => show.
             setShowAutoRenewalConsentCheckbox(config?.showAutoRenewalConsentCheckbox !== false);
          
          }).catch((errors)=>{
            console.log("Error in loading frontend configuration")
          })
    }
    
    //Fetching address structure using delivery country code: from basket

    const getAddressStructure = async (value, basketId) => {

        //reinitializing state on fetch of address structure on country change
        setInitialFilledState({ COUNTRY: { filled: true, mandatory: true }})
       
        return APIGet({
            "controller": "country",
            "action": "getaddressstructure",
            "environment": environment,
            "identifier": value?.toLowerCase(),
            "data": {
                basketId: basketId
            }
          }).then((response) => {
           
            let addressfields = response.data.addressfields;
            let filteredFields = addressfields.filter(item=> item.fieldName !=="JOBTITLE" && item.fieldName !== "DEPARTMENT"); //removing jobtitle and department fields
            let companyField = addressfields.find((item) => (item.fieldName === "COMPANY"));
            
              setCompanyProperties(companyField)
              setDeliveryAddressStructure(filteredFields);
              setLoading(false);

          }).catch((errors) => {
        
            setLoading(false);
          });
        }

    //when we go back to delivery details block on clicking edit button
    useEffect(()=>{
          if(!sectionComplete.deliveryDetails){
           setBillingAddress({});
           setBillingCompany({});
           setErrorStates(errorStates=>({...errorStates, noPaymentSelected:false, autoRenewalNotTicked:false }))
          }
        }, [sectionComplete.deliveryDetails])


    useEffect(() => {
        if (basket?.lines) {
            basket.lines.forEach((variant, id) => {
                setphoneConfiguration(variant?.requirephone);
            })
        }  
    
    }, [basket])

    useEffect(()=>{
        
        //in case of only 1 payment method making it the default
      
        if(basket?.paymentTypes?.length===1 && paymentSelection.paymenttype===null && (sessionDeliveryDetails || usingLatestDeliveryDetails)){
            onChangePaymentSelection(basket?.paymentTypes[0]);
        }
       
     }, [basket, sessionDeliveryDetails])
 

    useEffect(() => {
        //for guest flow 
        //as soon as guest session starts
        if (guestSession) {
            
            //validating refresh token for guest
            checkForRefreshADToken(); // first call on mount
    
            const interval = setInterval(() => {
            checkForRefreshADToken(); // checking every minute
            }, 60000);

            if(fid){
                setFid(fid); 
            }

            return () => clearInterval(interval); //clearing the interval
        }

     
     }, [isGuest])    
    
    
     useEffect(()=>{
        if((alreadyPurchased.status==="true" || purchaseRestriction.status==="true") && !basket?.allowgifting){

            const checkoutStarted = sessionStorage.getItem("CheckoutStarted");
            const adToken = GetADToken();

            //to serialize checkout restricted after checkout started
            if(checkoutStarted && adToken && checkoutStartedFired==="true"){
            setActionName("Checkout restricted")  } //checkout restricted 
         }

     }, [checkoutStartedFired])

    useEffect(() => {
       
        let beginEventTriggered = sessionStorage.getItem("BeginEventTriggered");

        //only to fire if not already fired before on landingPage 
        if (metaData?.basketmetadata && beginEventTriggered === null) {
            gtmEventTriggers("begin_checkout");
            sessionStorage.setItem("BeginEventTriggered", true)
        }

        let adtoken = GetADToken();
        let loggedInUserEmail = sessionStorage.getItem("loggedInUserEmail")  //in case we have an already logged in user going through guest flow
        //web activity: for LOGGED IN user flows, if already not fired on landingPage then will fire here, to be fired once
        let checkoutStarted = sessionStorage.getItem("CheckoutStarted");
        let alreadyFiredFor = sessionStorage.getItem("CheckoutStartedFiredFor");
         
        //to be modified later *******
        
         if((!isGuest && !guestSession && (checkoutStarted === null)) || 
            (isGuest && guestSession && (checkoutStarted === "true") &&  (loggedInUserEmail && (adtoken.username !== loggedInUserEmail))) || 
            (!loggedInUserEmail && isGuest && guestSession && (checkoutStarted === null)) || 
            (isGuest && guestSession && (checkoutStarted === null) && (alreadyFiredFor===null) && loggedInUserEmail)||
            (isGuest && guestSession && (checkoutStarted === null) && (loggedInUserEmail && (adtoken.username !== loggedInUserEmail)))||
            (adToken && adToken?.isGuest && guestSession && discountFlow && (checkoutStarted===null))){

        //token is needed
               if (adtoken) {
                   setActionName("Checkout started");
                   if(discountFlow){
                    sessionStorage.setItem("CheckoutStarted", true);   
                   }
                  
                 }
         }

    }, [metaData?.basketmetadata])


    useEffect(() => {
       
        //min-shipping
        if (!isGuest && basket?.id && metaData?.basketmetadata && basket?.isdeliverypostaladdressrequired === false && basket?.allowgifting === false) {
            gtmEventTriggers("add_shipping_info"); 
            
        //min-billing  
        if (basket.collectbillingaddress === false) {
                gtmEventTriggers("add_billing_info");
            }
        }


        if (isGuest && guestSession && basket?.id && metaData?.basketmetadata && basket?.isdeliverypostaladdressrequired === false && basket?.allowgifting === false) {
            gtmEventTriggers("add_shipping_info");
 
            //when min-billing
            if (flags.collectbillingaddress === false) {
                gtmEventTriggers("add_billing_info");
            }
        }

    }, [basket?.id, metaData?.basketmetadata])    



    //auto-renewal checkbox depends on presence of CCC
    const CheckIsContinuousMethodPresent=(res)=>{
    let basket= res;
    let present= basket.paymentTypes.find((type, index)=>{
        return  (type.paymenttypeid===3 || type.paymenttypeid===7)
           })
    if(present){
        setIsContinuousMethodPresent(true)
       }
    }

   const handleAuthentication = (value) => {

        // Updates the state or perform other actions in the parent component

        setOAuthentication(value);
    };
    


    const onChangePaymentSelection = (value, basketData, reload) => {
      
        let paymentTypeName = value?.name;
        let basketValue = basketData || basket;
        
        setErrors("");
        setErrorStates(errorStates=>({...errorStates, noPaymentSelected:false, stripeCardIsInvalid:false}));
        
        //only to run when multiple payment methods
        if (basketValue?.paymentTypes?.length > 1) {

            //Reset basket call goes on payment method change.
            ResetBasket(fid).then(() => {
                console.log("Basket reset successful");
            }).catch((error) => {
                console.log("Basket reset failed");
            });

        }

        if(reload){
         
            setPaymentSelection({ paymenttype: null, updatepaymentrequestfunction: null })
            setPaymentElementReload(false);
        }

        if (paymentTypeName === "Paypal")
       {    
            setPaymentMethodErrors("");
            setIsPaypal(true);
            setIsDirectDebit(false);
            setPaymentSelection({ paymenttype : value, updatepaymentrequestfunction: UpdatePaypalPaymentRequest });
        }
        else if (paymentTypeName === "DirectDebit") {
            
            setPaymentMethodErrors("");
            setIsDirectDebit(true);
            setPaymentSelection({ paymenttype : value, updatepaymentrequestfunction: UpdateDirectDebitPaymentRequest });
        }
        else if (paymentTypeName === "Invoicecredit" || paymentTypeName === "Invoiceproforma") {
            
            setPaymentMethodErrors("");
            setIsDirectDebit(false);
            setPaymentSelection({ paymenttype: value, updatepaymentrequestfunction: UpdateInvoicePaymentRequest });
        }
        else if (paymentTypeName === "Creditdebitcard" || paymentTypeName === "Continuouscreditdebitcard") {
            
            setIsDirectDebit(false);
            
            if (basketValue.defaultpaymentprovider === "stripe") 
            {   
                //incase the initial call errs for bringing the stripe data
                if(paymentSelection.paymenttype!==null){
                    let userToken = GetADToken();
                    if (userToken?.partyid > 0) {
                        handleInitializePayment(value, basketValue);
                   }
                }
                setPaymentSelection({ paymenttype: value, updatepaymentrequestfunction: UpdateStripePaymentRequest});
              
              
            } 
            if (basketValue.defaultpaymentprovider === "worldpay") {
                
                setPaymentSelection({ paymenttype: value, updatepaymentrequestfunction: null });
            }
        }
       
    }


    const onVatNoChanged = (value) => {
        setVatNo(value);
    }

    const paymentErrorHandler = (error) => {

        // For Link payments show a friendly, payment-method-specific message instead of the generic
        // "An unexpected error occurred" text. paymenttypename is the RAW payment type name
        // (e.g. "Link bank" / "Link continuous"), so normalise it and prefix-match on "link".
        const selectedPaymentTypeName = paymentSelection?.paymenttype?.paymenttypename
            ?? paymentSelection?.paymenttype?.name;
        const isLinkPayment = selectedPaymentTypeName?.toLowerCase()?.replace(/[^a-z]/g, "")?.startsWith("link");

        if (isLinkPayment) {
            setErrors(["linkpayment.paymenterror"]);
            focusOnFirstError(errorContainerRef);
            return;
        }

        var paymentError = [];
        paymentError.push(error);
        setErrors(paymentError);
        focusOnFirstError(errorContainerRef);
    }

    //for stripe card decline state
 
    useEffect(() => {
        if (errorStates.cardDeclined) {
            focusOnFirstError(errorContainerRef);
        }
    }, [errorStates.cardDeclined]);

    
     //when we go back to delivery details block on clicking edit button

     useEffect(()=>{
        if(!sectionComplete.deliveryDetails){
         setBillingAddress({});
         setBillingCompany({});
         setErrorStates(errorStates=>({...errorStates, noPaymentSelected:false, autoRenewalNotTicked:false }))
        }
      }, [sectionComplete.deliveryDetails])

    //************************************Passes vat is checked and applied from child  *****************************// 
    // verifies  if the purchase as a  business  is checked or not - VA
    const handleVatCheckedChange = (checked) => {
        setIsVatChecked( checked);
    };
    // verifies  if the VAT is applied  or not - VA
    const handleVatApplied = (applied) => { 
      

        setIsVatApplied(applied); 
    };
 
    useEffect(()=>{

        if(paymentElementReload){
            if (basket?.defaultpaymentprovider === "stripe" && paymentSelection?.paymenttype?.name === "Creditdebitcard") {
               onChangePaymentSelection(paymentSelection.paymenttype, basket, true);
             }
             
             if(!paymentSelection.paymenttype){
                setPaymentElementReload(false);
            } 
          }

        

    }, [paymentElementReload])
   
   //************************************Validating methods begin *****************************//  
    const validateBilling = () => {
      
        let detailsFilled = true;
        let newIsFilled = { ...IsFilledBilling };
        let newIsInvalid = { ...isInvalidBilling };
       
        //when address lookup state is on--and no address values are there
        if (flags.collectbillingaddress && !usingLatestBillingDetails) {
            if (billingAddress.ADDRESS1 === undefined) {
                newIsFilled = { ...newIsFilled, ADDRESS: { filled: false, mandatory: true } };
                detailsFilled = false
            }
            else if (checkIsInvalid(billingAddress.ADDRESS1, "address")) {
                newIsInvalid = { ...newIsInvalid, ADDRESS: { invalid: true, mandatory: true } };
                detailsFilled = false
            }
        }

        //when only country value is needed in min billing
        if (!billingAddress.COUNTRY && !usingLatestBillingDetails) {
            newIsFilled = { ...newIsFilled, COUNTRY: { filled: false, mandatory: true } }
            detailsFilled = false
        }
        

       //scenarios when billing company is mandatory and hideCompanyOnCheckout is false
       if ((IsFilledBilling.COMPANY?.mandatory && showCompany) || (basket?.offertypename === "corporate subscription")) {
        if (!billingCompany?.COMPANY || billingCompany?.COMPANY?.length <= 0) {
            newIsFilled = { ...newIsFilled, COMPANY: { filled: false, mandatory: true } };
                detailsFilled = false
            }
        }
        
        //checing validitity of billing company value
        if (billingCompany?.COMPANY?.length > 0 && checkIsInvalid(billingCompany?.COMPANY, "address")) {
            newIsInvalid = { ...newIsInvalid, COMPANY: { invalid: true, mandatory: false } }
            detailsFilled = false
        }
        else {
            newIsInvalid = { ...newIsInvalid, COMPANY: { invalid: false, mandatory: false } }
        }

        //checking validity of fields other than company
        if(!usingLatestBillingDetails){
        for (let key in IsFilledBilling) { 
            if (key !== "ADDRESS" && key !== "COUNTRY" && key !== "RECIPIENT" && key !== "COMPANY") {
                if ( IsFilledBilling[key]?.mandatory && (billingAddress[key] === '' || !billingAddress[key])) {
                    newIsFilled = { ...newIsFilled, [key]: { filled: false, mandatory: true } }
                    detailsFilled = false
                }
                else if ((billingAddress[key] && billingAddress[key] !== '') && checkIsInvalid(billingAddress[key], "address")) {
                    newIsInvalid = { ...newIsInvalid, [key]: { invalid: true, mandatory: true } };
                    detailsFilled = false
                }
            }
        }
        }

       //validation for vat only needed when vat box  is checked
        if (isVatChecked) {
            if (!billingCompany?.COMPANY || billingCompany.COMPANY.length <= 0) {
                detailsFilled = false
            }
                if (!isVatApplied) { 
                if (billingCompany.vatNo === undefined || billingCompany.vatNo > 0) {
                    setErrorStates(errorStates => ({ ...errorStates, isVatEmpty: true }));
                    detailsFilled = false
                } else {
                    setErrorStates(errorStates => ({ ...errorStates, isVatEmpty: false }));
                    detailsFilled = true
                } }}
      
        setIsFilledBilling({ ...newIsFilled })
        setIsInvalidBilling({ ...newIsInvalid })
        setSectionComplete(sectionComplete => ({ ...sectionComplete, billingDetails: detailsFilled }))

        if(!detailsFilled){
            focusOnFirstError(errorContainerRef);
        }
        else{
           
            if(flags.collectbillingaddress || flags.isdeliverypostaladdressrequired){
               gtmEventTriggers("add_billing_info");  //when billing address is required
            }
         }
      return detailsFilled;
    }

 
    const validateDelivery = () => {
       
        let detailsFilled = true;
        let newIsFilled = { ...IsFilledDelivery };
        let newIsInvalid = { ...isInvalidDelivery };

        if (flags.isdeliverypostaladdressrequired) {
            if (deliveryAddress.ADDRESS1 === undefined) {
                newIsFilled = { ...newIsFilled, ADDRESS: { filled: false, mandatory: true } };
                detailsFilled = false
            }
            else if (checkIsInvalid(deliveryAddress.ADDRESS1, "address")) {
                newIsInvalid = { ...newIsInvalid, ADDRESS: { invalid: true, mandatory: true } };
                detailsFilled = false
            }
        }

        if (!deliveryAddress.COUNTRY) {
            newIsFilled = { ...newIsFilled, COUNTRY: { filled: false, mandatory: true } }
            detailsFilled = false
        }

        if ((purchasingFor === "gift" && basket.allowgifting) || (!purchasingFor && basket.allowgifting)) {
            if (!optionalEmail) {
                for (let key in recipientDetails) {
                    if (recipientDetails[key] === '') {
                        newIsFilled = { ...newIsFilled, RECIPIENT: { filled: "not_valid", mandatory: true } }
                        detailsFilled = false;
                    }
                }
            }
            else {
                for (let key in recipientDetails) {
                    if (recipientDetails[key] === '' && key !== "userEmail") {
                        newIsFilled = { ...newIsFilled, RECIPIENT: { filled: "not_valid", mandatory: true } }
                        detailsFilled = false;
                    }
                }
            }
        }
      
        if(flags.isdeliverypostaladdressrequired){
        for (let key in IsFilledDelivery) {
            if (key !== "ADDRESS" && key !== "RECIPIENT" && key !== "COMPANY") {
                if ((!deliveryAddress[key] || deliveryAddress[key] === '') && IsFilledDelivery[key]?.mandatory) {
                    newIsFilled = { ...newIsFilled, [key]: { filled: false, mandatory: true } }
                    detailsFilled = false
                }
                else if ((deliveryAddress[key] && deliveryAddress[key] !== '') && checkIsInvalid(deliveryAddress[key], "address")) {
                    newIsInvalid = { ...newIsInvalid, [key]: { invalid: true, mandatory: true } };
                    detailsFilled = false
                }
            }
        }}
        
     //for checking delivery company field with mandatory setting on and hideCompanyOnCheckout to be false
     if(!deliveryCompany?.COMPANY && IsFilledDelivery?.COMPANY?.mandatory && showCompany){
            newIsFilled = { ...newIsFilled, COMPANY: { filled: false, mandatory: true } }
            detailsFilled = false
        } 
        
        if (deliveryCompany?.COMPANY?.length > 0 && checkIsInvalid(deliveryCompany?.COMPANY, "address")) {
            newIsInvalid = { ...newIsInvalid, COMPANY: { invalid: true, mandatory: false } }
            detailsFilled = false;
        }
        else {
            newIsInvalid = { ...newIsInvalid, COMPANY: { invalid: false, mandatory: false } }
        }

        setIsFilledDelivery({ ...newIsFilled })
        setIsInvalidDelivery({ ...newIsInvalid })
        setSectionComplete(sectionComplete => ({ ...sectionComplete, deliveryDetails: detailsFilled }))

        if(!detailsFilled){
            focusOnFirstError(errorContainerRef);
        } 
      
        return detailsFilled; }


    const validatePaymentSelection = ()=>{
        if(!paymentSelection.paymenttype ){
            setErrorStates(errorStates=>({...errorStates, noPaymentSelected:true}));
        return false;
        }
        else{
           setErrorStates(errorStates=>({...errorStates, noPaymentSelected:false}));
           return true;
        }
    }

    const validateDpaSelection = ()=>{
        // When the consent checkbox is hidden via config, skip the "not ticked" enforcement entirely.
        if(!IsAutoRenewalChecked && IsContinuousMethodPresent && showAutoRenewalConsentCheckbox){
            setErrorStates(errorStates=>({...errorStates, autoRenewalNotTicked:true}));
            return false;
        }
        else{
           setErrorStates(errorStates=>({...errorStates, autoRenewalNotTicked:false}));
           return true;
        }
    }


    const validateCreditCardHolderName =()=>{
        if(creditCardHolderName.length<=0){
            setErrorStates(errorStates => ({ ...errorStates, cardHolderNameBlank: true }));
            return false;
        }
        else{
            setErrorStates(errorStates => ({ ...errorStates, cardHolderNameBlank: false }));
            return true;
        }
    }

 
    /******************************************************Direct debit functions******************************************** */

    const validateDDAuth = () => {
        if (isDirectDebit) {
            if (!IsAuthDebitCardChecked) {
                setErrorStates(errorStates => ({ ...errorStates, authDD: true }));
                setShowError(true);
                return false;
            }
            else {
                setErrorStates(errorStates => ({ ...errorStates, authDD: false }));
                return true;
            }
        }
    }
    
    const validateDDName = () => {
        if (isDirectDebit) { 
        if (ddDetails.accountholder.length <= 0) {
          
            setErrorStates(errorStates => ({ ...errorStates, isBlankAccountNameDD: true }));
            return false;
        }
        else {
            setErrorStates(errorStates => ({ ...errorStates, isBlankAccountNameDD: false }));
            return true;
            }
        }
    }

    const validateDDBank = () => {
        if (isDirectDebit) {
            if (ddDetails.bankname.length <= 0) {
                setErrorStates(errorStates => ({ ...errorStates, isBlankBankDD: true }));
                return false;
            }
            else {
                setErrorStates(errorStates => ({ ...errorStates, isBlankBankDD: false }));
                return true;
            }
        }
    }

    const validateDDAccountNumber= () => {
          
        let valid =false;
       
            if (ddDetails.accountnumber.length <= 0) {
                setErrorStates(errorStates => ({ ...errorStates, isBlankAccountNumberDD: true })); 
                valid = false;
            }
            else {
                 setErrorStates(errorStates => ({ ...errorStates, isBlankAccountNumberDD: false })); 
                 if ((ddDetails.accountnumber?.match(accountNumberRegex) || []).length <= 0) {
                    setErrorStates(errorStates=>({...errorStates, invalidFormatAccountNumberDD:true}));
                    valid = false;
                 }
                else {
                    setErrorStates(errorStates=>({...errorStates, invalidFormatAccountNumberDD:false}));
                    valid = true;
                }
            }
            return valid;
       }

    const validateDDSortCode= () => {
        let valid = false;
   
            if (ddDetails.sortcode.length <= 0) {
                setErrorStates(errorStates => ({ ...errorStates, isBlankSortCodeDD: true }));
                valid=false;
            }
            else {
                setErrorStates(errorStates => ({ ...errorStates, isBlankSortCodeDD: false }));
                if ((ddDetails.sortcode?.match(sortCodeRegex) || []).length <= 0) {
                    setErrorStates(errorStates=>({...errorStates, invalidFormatSortCodeDD:true}));
                    valid = false;
                 }
                else {
                    setErrorStates(errorStates=>({...errorStates, invalidFormatSortCodeDD:false}));
                    valid = true;
                }
              }
          return valid;
     }

    const validateVat = () => {
        //check validations of VAT is empty - VA
      
    }


    /*---------------------------------------------Loqate Bank Details Verification---------------------------------------------*/

    const validateLoqateBankVerification = () => {
        return new Promise((resolve, reject) => { 
            let accountNoValid = ddDetails.accountnumber && !errorStates.invalidFormatAccountNumberDD;
            let sortCodeValid = ddDetails.sortcode && !errorStates.invalidFormatSortCodeDD;
            let accountNo=ddDetails.accountnumber;
            let sortCode=ddDetails.sortcode;
            let accountName=ddDetails.accountholder
            let bankName=ddDetails.bankname;
           

            //All fields if present then only the call should be allowed to go
    
            if (BankConfiguration && accountNoValid && sortCodeValid && accountName && bankName) {
                
                setErrorStates(errorStates=>({...errorStates, invalidAccountNumberDD:false, invalidSortCodeDD:false}));

                const url = 'https://api.addressy.com/BankAccountValidation/Batch/Validate/v1.00/json3.ws';
                const params = new URLSearchParams();
                params.append("Key", BankVerificationAPIKey);
                params.append("AccountNumbers", encodeURIComponent(accountNo));
                params.append("SortCodes", encodeURIComponent(sortCode));
    
                fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: params })
                    .then(response => response.json())
                    .then(data => {
                       
                        if (data.Items.length === 1 && !data.Items[0].Error ) {
                        resolve(data.Items);
                        loqateRequestLogs("1", data.Items[0], 2 ) //loqate request log for bank validation

                   } })
                    .catch(error => {
                      reject(error);
                    });

            } else {
                 resolve([]);
            }
        });
    };


    async function loqateBankVerificationResponseHandler() {
        let verified = false;
        let bankname =  "";
        try {

            let BankValidation = await validateLoqateBankVerification();

            setBankValidation(BankValidation);

            if (BankValidation.length > 0) {
                const statusInformation = BankValidation[0]?.StatusInformation;
                bankname = BankValidation[0]?.Bank;
                  
                //if the verification call is successful, typed in bank name will be overridden by the bank name in reponse.

                if(bankname){
                  setddDetails(ddDetails=>({ ...ddDetails, bankname: bankname}))
                }
    
                if (statusInformation === undefined) {

                    verified = false;

                } else if (statusInformation === 'InvalidAccountNumber') {
                    setErrorStates(errorStates=>({...errorStates, invalidAccountNumberDD:true}));
                    setErrorStates(errorStates=>({...errorStates, invalidSortCodeDD:false}));
                    verified = false;

                } else if (statusInformation === 'UnknownSortCode') {
                    setErrorStates(errorStates=>({...errorStates, invalidSortCodeDD:true}));
                    setErrorStates(errorStates=>({...errorStates, invalidAccountNumberDD:false}));
                    verified = false;

                } else if (statusInformation === 'OK') {
                    setErrorStates(errorStates=>({...errorStates, invalidAccountNumberDD:false}));
                    setErrorStates(errorStates=>({...errorStates, invalidSortCodeDD:false}));
                  
                    verified = true;
                }
            } else {
                verified = false;
            }
    
            return {"status": verified, "bankname": bankname} ;

        } catch (error) {
            console.error('Error in loqateBankVerificationResult:', error);
            throw error; 
        }
    };

    
   //****************************************validating methods end *********************************//
   
  //***************************************final payment call***************************************//


    
    //common variables 
     let loqateBankName = "";
     let loqateBankVerificationStatus = "";
     let offertypename = basket?.offertypename;
   

    const finalValidation = async() => {
        let validated=false;
        
        //general validations
        let billing = validateBilling();
        let delivery = usingLatestDeliveryDetails ? true : validateDelivery();
        let payment = (validatePaymentSelection() || basket.offertypename === "free trial");
        let autoRenewal = validateDpaSelection();
        let phoneValidate = (phoneConfiguration === "Required" || phoneConfiguration === "Optional") ? phoneRef?.current?.validatePhoneNumber("", "onSubmit") : true;

        //direct debit validation functions
        let authDD = validateDDAuth();
        let accountNoDDValid=validateDDAccountNumber();
        let accountNameDDValid=validateDDName();
        let bankDDValid=validateDDBank();
        let sortcodeDDValid=validateDDSortCode();
        let directDebit= (accountNoDDValid && accountNameDDValid && bankDDValid && sortcodeDDValid)
        
        //only to run when bankValidation is needed
        if (BankConfiguration) {
            let loqateBankVerificationResult = await loqateBankVerificationResponseHandler();
            loqateBankName = loqateBankVerificationResult?.bankname
            loqateBankVerificationStatus = loqateBankVerificationResult?.status
        }

        //final checks
        if ((isDirectDebit ? billing && delivery && payment && autoRenewal && authDD && directDebit &&  phoneValidate && (!BankConfiguration || loqateBankVerificationStatus)
            : offertypename === "free trial" ? delivery && autoRenewal && phoneValidate  //free trial 
            : guestSession ? (billing && delivery && payment && autoRenewal) : (billing && delivery && payment && autoRenewal & phoneValidate))) {

            validated= true;
        }
        else {

            focusOnFirstError(errorContainerRef);
            validated= false;
        }

        return validated;

    }



   const onSubmitPayment = async(event) => {
       
       event.preventDefault();
       setErrors("")
       setErrorStates(errorStates => ({ ...errorStates, cardDeclined: false }))
 
       //worldplay flow change
       let isUsingWorldPay = (basket.defaultpaymentprovider === "worldpay" && (paymentSelection?.paymenttype?.name === "Creditdebitcard" || paymentSelection?.paymenttype?.name === "Continuouscreditdebitcard"))  

       let fieldsValidated= await finalValidation();

       if(fieldsValidated){
         

           setIsLoading(true);
           let data = {};
           let countryCodes={billingCountryCode:billingCountryCode, deliveryCountryCode:deliveryCountryCode}

           //in case of bank validation the bank name will be updated from the loqate response
           let AccountDetails= (loqateBankName) ? {...ddDetails, bankname: loqateBankName} : ddDetails
           let stripeIntentId = "NA";

           if (stripeCredentials)
               stripeIntentId = stripeCredentials.intentid;

            if(guestSession){

                let guestUserDetails= location.state ? location.state.guestUser :  (adToken?.isGuest === true) ? adToken : ""

               let guestPurchaserName= splitName(guestUserDetails?.name);
             
               data = {
                    "purchaser": {
                        "Token": guestUserDetails?.token,
                        "email": guestUserDetails?.username,
                        "Firstname": guestPurchaserName[0],
                        "Surname": guestPurchaserName[1],
                        "telephonenumber": phoneNumber,
                        "company": (offertypename==="free trial") ? deliveryCompany : billingCompany,
                        "address": (offertypename==="free trial") ? deliveryAddress : billingAddress,
                        "dpaFlag":IsMarketingPreferencesChecked
                       
                    },
                    "recipient": (purchasingFor==="gift" && basket.allowgifting)  || (!purchasingFor && basket.allowgifting) ? {
                        "email":  recipientDetails.userEmail ,
                        "Surname": recipientDetails?.lastName,
                        "Firstname": recipientDetails?.firstName,
                        "Token" : giftRecipientDetails.token || "",
                        "PartyId" : giftRecipientDetails.partyid || "",
                        "company": deliveryCompany,
                        "address": deliveryAddress
                    } : {
                        "telephonenumber": phoneNumber,   //when no recipient
                        "Firstname": guestPurchaserName[0],
                        "Surname": guestPurchaserName[1],
                        "email":   guestUserDetails?.username,                        
                        "company": deliveryCompany,
                        "address": deliveryAddress
                    },
                    "payment": {
                        "PaymentType": paymentSelection?.paymenttype,
                        "AccountDetail": AccountDetails,
                        // When the consent checkbox is hidden via config, treat consent as implicitly given.
                        "ContinuousPaymentAuthorised": showAutoRenewalConsentCheckbox ? IsAutoRenewalChecked : true,
                        "PaymentAPIReference" : stripeIntentId,
                    }
                };
            } else{
                
                let loggedInPurchaserName = splitName(auth?.userData?.name);
                
                data = {
                "purchaser": {
                    "Token": auth?.userData?.token,
                    "email": auth?.userData?.username,
                    "Firstname":loggedInPurchaserName[0],
                    "Surname":loggedInPurchaserName[1],
                    "company": (offertypename==="free trial") ? deliveryCompany : billingCompany ,
                    "address": (offertypename==="free trial") ? deliveryAddress : billingAddress,
                    "telephonenumber": phoneNumber 
                },
                "recipient":(purchasingFor==="gift" && basket.allowgifting)  || (!purchasingFor && basket.allowgifting) ?  {
                        "email":  recipientDetails.userEmail ,
                        "Surname": recipientDetails?.lastName,
                        "Firstname": recipientDetails?.firstName,
                        "Token" : giftRecipientDetails.token || "" ,
                        "PartyId" : giftRecipientDetails.partyid ||  "",
                        "company": deliveryCompany,
                        "address": deliveryAddress
                } :{
                    "telephonenumber": phoneNumber,    //when no recipient
                    "Firstname":loggedInPurchaserName[0],
                    "Surname":loggedInPurchaserName[1],
                    "email":  auth?.userData?.username,
                    "company": deliveryCompany,
                    "address": deliveryAddress,
                },
                "payment": {
                    "PaymentType":  paymentSelection?.paymenttype,
                    "AccountDetail": AccountDetails,
                    // When the consent checkbox is hidden via config, treat consent as implicitly given.
                    "ContinuousPaymentAuthorised": showAutoRenewalConsentCheckbox ? IsAutoRenewalChecked : true,
                    "PaymentAPIReference": stripeIntentId,
                }
            };
        }
        
          let paymentTypeName = paymentSelection?.paymenttype?.name;
         
          if ((paymentTypeName === "Creditdebitcard" || paymentTypeName === "Continuouscreditdebitcard") && basket.defaultpaymentprovider === "stripe")
          {   
            Promise.all([(stripeMethodName ==="card" ? validateCreditCardHolderName():""), paymentConfirmRef.current.elements.submit()])
            .then(([validationResult, submitResult]) => { 
                let cardBrandValid = true;
                let cmplete = false;

                paymentConfirmRef.current.createPaymentMethod(data.purchaser, countryCodes)
                    .then((paymentMethodResult) => {

                        console.log('Payment method created successfully:', paymentMethodResult);

                        let stripeCardBrand = paymentMethodResult.card?.brand;
                       
                        if(stripeCardBrand){
                        //validate card brand based on product offer selected payment cards
                        cardBrandValid = false;
                        let sp = paymentSelection?.paymenttype?.subpaymenttypes;
                        if (sp) {
                            cardBrandValid = sp.some(item => item.name?.toLowerCase().startsWith(stripeCardBrand?.toLowerCase()));
                        }
                        cardBrandValid = cardBrandValid || !checkVariantCardPaymentBrand;
                       
                        if (!cardBrandValid) {

                            let cardBrandErrors = ["error.cardbrandnotsupported"];
                            paymentErrorHandler(cardBrandErrors)
                            setErrorStates(errorStates=>({...errorStates, stripeCardIsInvalid:true }))

                        } else{
                            
                            setErrorStates(errorStates=>({...errorStates, stripeCardIsInvalid:false }))
                        }
                        }
                        if ((stripeMethodName ==="card" && validationResult && !submitResult.error && cardBrandValid) || (stripeMethodName !=="card" && !submitResult.error) ) {
                            SaveToOrder({ fid: fid, data: data }).then((oresult) => {

                                // add the orderId into the payment request

                                if (oresult.ordertype === "free trial" /*|| oresult.ordertype === "paid free trial"*/) {
                                    if (oresult.ordertype === "paid free trial") {
                                        paymentConfirmRef.current.confirmPayment(event, oresult.ordertype === "paid free trial");
                                    }
                                    else {
                                        APIPost({
                                            "controller": "freetrial",
                                            "action": "completefreetrialsetup",
                                            "data": {
                                                "fid": fid
                                            },
                                            "environment": null,
                                            "identifier": null
                                        }).then((ftresponse) => {

                                        let url = window.location.protocol + "//" + window.location.host + "/thankyou/" + ftresponse.data.OrderId;
                                       
                                        let updatedUrl= appendClientQueryParams(url);
                                        window.location.href = updatedUrl;

                                        }).catch((fterror) => {
                                            paymentErrorHandler(fterror);
                                            setIsLoading(false);
                                        });
                                    }
                                }
                                else if (paymentSelection.updatepaymentrequestfunction) {
                                   
                                    paymentSelection.updatepaymentrequestfunction({ "basket": basket, "orderId": oresult.orderId, "stripeIntentId": stripeIntentId }).then((upresult) => {

                                    paymentConfirmRef.current.confirmPayment(event, (basket.offertypename === "paid free trial" || basket?.iszerovalue), oresult.orderId, data.purchaser, data.recipient, countryCodes);
                                }).catch((uperror) => {
                                    paymentErrorHandler(uperror);
                                    setIsLoading(false)
                                });
                            }
                            else {
                                paymentConfirmRef.current.confirmPayment(event, (basket.offertypename === "paid free trial" || basket?.iszerovalue), oresult.orderId, data.purchaser, data.recipient, countryCodes);
                            }
                        }).catch((error) => {
                            if (error.length && error.includes("error.basketcompletedorder")) {

                                    // Handle the specific error related to a completed order

                                    setBasketErrors(error)
                                    setBasket({});
                                }
                                else {
                                    paymentErrorHandler(error);
                                }
                                setIsLoading(false)
                            });
                        }
                        else {
                            setIsLoading(false)
                        }
                        ///////////////////////////////////
                    })
                    .catch((error) => {
                        let err = 'An error occurred during payment method creation:';
                        let cardBrandErrors = [err];
                        setErrors(cardBrandErrors);
                        console.error(err, error);
                        setIsLoading(false);
                    });


                ///////////////////////////////////////////////
            })
             
          }
          else { 

              SaveToOrder({ fid: fid, data: data }).then((oresult) => {
                  if (oresult.ordertype === "free trial" || (oresult.ordertype === "paid free trial" && !isUsingWorldPay)) {
                      let action = "completefreetrialsetup";
                      if (oresult.ordertype === "paid free trial") {
                          action = "completetokenisedfreetrialsetup";
                      }
                      APIPost({
                          "controller": "freetrial",
                          "action": action,
                          "data": {
                              "fid": fid
                          },
                          "environment": null,
                          "identifier": null
                      }).then((ftresponse) => {

                        let url= window.location.protocol + "//" + window.location.host + "/thankyou/" + oresult.orderId ;
                        let updatedUrl= appendClientQueryParams(url);
                        window.location.href = updatedUrl;
                          
                      }).catch((fterror) => {
                          paymentErrorHandler(fterror);
                          setIsLoading(false);
                      })
                  }
                  else if (isUsingWorldPay) {
                      //once basket gets converted to order to show worldpay card details section
                      setShowWorldPay(true);
                      setIsLoading(false);

                  }
                  else {
                      if (paymentSelection.updatepaymentrequestfunction) {
                          // add the orderId into the payment request
                          paymentSelection.updatepaymentrequestfunction({ "basket": basket, "orderId": oresult.orderId }).then((upresult) => {
                              paymentConfirmRef.current.confirmPayment(event, (basket.offertypename === "paid free trial" || basket?.iszerovalue), oresult.orderId, data.purchaser, data.recipient, countryCodes);
                          }).catch((uperror) => {
                              paymentErrorHandler(uperror);
                              setIsLoading(false)
                          });
                      } else {
                          paymentConfirmRef.current.confirmPayment(event, (basket.offertypename === "paid free trial" || basket?.iszerovalue), oresult.orderId, data.purchaser, data.recipient, countryCodes);
                      }
                  }

            }).catch((error) => {

                  //basket error handling
                  
                  if (error.length && error.includes("error.basketcompletedorder")) {

                    // Handle the specific error related to a completed order

                   setBasketErrors(error)
                   setBasket({});
                } 
                else {
                    paymentErrorHandler(error);
                }
               setIsLoading(false)
            });}
      }
      else {

          focusOnFirstError(errorContainerRef);
          setIsLoading(false)
      }

        //window.location.href =  window.location.protocol + "//" + window.location.host + "/OrderComplete";
    }

    //******************************************final payment call ends********************************/

    let paymentButtonText = t('payment.subscribebutton');
    let continueToWorldpayButtonText="";

    if (paymentSelection === "Paypal") {
        paymentButtonText = t('payment.paywithpaypalbutton');

    } else if((paymentSelection?.paymenttype?.name === "Creditdebitcard" || paymentSelection?.paymenttype?.name === "Continuouscreditdebitcard") && basket.defaultpaymentprovider==="worldpay"){

         //worldpay continue button text

        continueToWorldpayButtonText = t('payment.paywithworldpaybutton');
    }

    let submitDisabled = false;

    const termsText = props.brandingElement?.termsText || '';
    let discountIneligible = props.brandingElement?.discountIneligible || '';
    
    //stripe initialising method

    useEffect(()=>{

    if(enableWallets && stripePublicKey && basket){

        if(walletMethods===""){
           checkForWalletMethods(basket, stripePublicKey, setWalletMethods)
        }
    }

    }, [enableWallets, stripePublicKey, basket])

    const handleInitializePayment = (paymenttype, basketData)=>{

        if(!stripeCreds){

            InitialiseStripe({ "paymentSelection": paymenttype?.paymenttypeid, "basket": basketData}).then((stripeResult) => {
                
                let stripePublicKey = stripeResult?.publickey;
                setStripePublicKey(stripePublicKey);
                setStripeCredentials(stripeResult);
                sessionStorage.setItem("stripeData", JSON.stringify(stripeResult));   //keeping publicKey, secret and paymentIntent in session for any rerenders to avoid multiple payment intents
              
              }).catch((error) => {
               
                if(error.response.status===500){
                    setPaymentMethodErrors("500_errors")
                }
              });
        }}

    // to render card-Details Ui as per selection
    const displayForm = () => {
      
        const paymentTypeName = paymentSelection?.paymenttype?.name;
       
        if (paymentTypeName === "Paypal") {
            return <PaypalForm onAuthentication={handleAuthentication} billingCountryCode={billingCountryCode} billingAddress={billingAddress} basket={basket} paymentTypeId={paymentSelection.paymenttype.paymenttypeid} ref={paymentConfirmRef} onError={paymentErrorHandler} autoRenewal={IsAutoRenewalChecked} errorStates={errorStates} /> 
        }
        else if (paymentTypeName === "DirectDebit") {
            return BankConfiguration ? <DirectDebitForm basket={basket} setddDetails={setddDetails} ddDetails={ddDetails}  ref={paymentConfirmRef}  onError={paymentErrorHandler} ddTerms={props?.brandingElement?.ddTermsText} setIsAuthDebitCardChecked={setIsAuthDebitCardChecked} setErrorStates={setErrorStates} errorStates={errorStates} showError={showError} BankConfiguration={BankConfiguration} BankValidation={BankValidation}/> 
            : <DirectDebitForm basket={basket} setddDetails={setddDetails} ddDetails={ddDetails} onError={paymentErrorHandler} ref={paymentConfirmRef} ddTerms={props?.brandingElement?.ddTermsText} setIsAuthDebitCardChecked={setIsAuthDebitCardChecked} setErrorStates={setErrorStates} errorStates={errorStates} showError={showError}/>
        }
        else if (paymentTypeName === "Invoicecredit" || paymentTypeName === "Invoiceproforma") {
            return <Invoice basket={basket} ref={paymentConfirmRef} setErrorStates={setErrorStates} errorStates={errorStates} showError={showError} />
        }
        else if (paymentTypeName === "Creditdebitcard" || paymentTypeName === "Continuouscreditdebitcard") {
            if ( basket.defaultpaymentprovider === "stripe") {  
                if (stripeCredentials && paymentSelection?.updatepaymentrequestfunction ) {
                 return (<>
                        <div id="stripe-dropin-container">
                           
                            <StripeForm paymentElementReload={paymentElementReload} stripeAdditionalPaymentTypes={stripeAdditionalPaymentTypes} enableWallets={enableWallets} setStripeMethodName={setStripeMethodName} errorStates={errorStates} setErrorStates={setErrorStates} creditCardHolderName={creditCardHolderName} setCreditCardHolderName={setCreditCardHolderName} isLoading={isLoading} setIsLoading={setIsLoading} stripeCredentials={stripeCredentials} basket={basket} paymentTypeId={paymentSelection.paymenttype.paymenttypeid} paymentTypeName={paymentSelection.paymenttype.paymenttypename} ref={paymentConfirmRef} onError={paymentErrorHandler}/>
                        </div> 
                    </> )                  
                }
            }
            else if (basket.defaultpaymentprovider === "worldpay") {
                return (<>                   
                    <div id="wpcontainer"><WorldPayForm
                        billingCountryCode={billingCountryCode}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        wpHostedURL={wpHostedURL}
                        billingAddress={billingAddress}
                        onSubmitPayment={onSubmitPayment}
                        basket={basket}
                        paymentTypeName={paymentSelection.paymenttype.paymenttypename}
                        setPaymentMethodErrors={setPaymentMethodErrors}
                        paymentTypeId={paymentSelection.paymenttype.paymenttypeid}
                        ref={paymentConfirmRef}
                        onError={paymentErrorHandler} />
                    </div>
                </>)
            }} 
        
        }
   
    //**********************************modal functions begin ***********************************//


    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    }

    const handleResize = () => {

        // Update isOnModal based on the current state of the modal

        setIsMobile(windowSize < 1000 && showModal);
    };

    useEffect(() => {

        // Attach the resize event listener

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [windowSize]);

    useEffect(() => {
        if (showModal) {

            // Disable scrolling on the entire page when the modal is open

            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
        } else {

            // Re-enable scrolling when the modal is closed

            document.body.style.overflow = 'auto';
            document.body.style.position = 'relative';
        }

        // Cleanup style on component unmount
        return () => {
            document.body.style.overflow = 'auto';
            document.body.style.position = 'relative';

        };
    }, [showModal]);

    const basketSummaryForMobile=()=>{

        let prepaymenttotalgross = basket?.prepaymenttotalgross
        let isOrderAnUpgrade = basket?.isupgrade;
        
        if(isOrderAnUpgrade){
            sessionStorage.setItem("isOrderAnUpgrade", isOrderAnUpgrade);
        }
        
        return  <div className="item-container">
        <div class="border-seperator"></div>
        <div class="item-wrapper">
            <div class="two-columns-row">
                <span>Sub-total</span>
                    <span class="order-price"> {basket?.currencysymbol}{basket?.subtotal?.toFixed(2)}</span>
            </div>
            {isOrderAnUpgrade && <div className="two-columns-row"> 
                               <span>{t('basket.prepaymenttotallabel')}</span> 
                               <span className="order-price">{t("upgrade.negativesign")}{basket.currencysymbol}{prepaymenttotalgross?.toFixed(2)}</span>
                            </div>
                      }
            <div class="two-columns-row">
                <span>Tax</span>
                    <span class="order-price">{basket?.currencysymbol}{basket?.tax?.toFixed(2)}</span>
            </div>
            {basket.delivery &&
                <div className="two-columns-row">
                    <span>Delivery</span>
                        <span class="order-price">{basket?.currencysymbol}{basket?.delivery?.toFixed(2)}</span>
                </div>
            }
            <div class="border-seperator"></div>
            <div class="two-columns-row">
                <span class="order-price">
                    <strong> Order total</strong>
                </span>
                    <span class="order-price">
                        <strong>{basket?.currencysymbol}{isOrderAnUpgrade ? basket?.grosswithrebate?.toFixed(2) : basket?.gross?.toFixed(2)}</strong>
                </span>
            </div>
        </div>
        <div class="border-seperator"></div>
    </div>
    }

    //****************************************modal functions end***********************//


    const handleOnBackButton = () =>{

        //should take us to step 1 of world pay flow

        setShowWorldPay(false);
    }

    //showing and setting delivery details on completion of the ste, settings also needed for billing section
    const showSavedDeliveryDetails=(deliveryDetails)=>{
  
    let temp= {};

    try{
       temp=deliveryDetails;
    }catch(e){
        console.log("Issue with retrival of delivery data")
    }
   
    let recipient= temp.recipient;
    let company = temp.company;
    let address = temp.address
    let phoneNumber = temp.phoneNumber;
    let isFilledDelivery = temp.IsFilledDelivery;
    let giftRecipientDetails = temp.giftRecipientDetails;

    if(recipient){
        setRecipientDetails(recipient);

    }
    if(company){
        setDeliveryCompany(company);
       
    }
    if(address){
        setDeliveryAddress(address);
       
    }

    if(phoneNumber){
        setPhoneNumber(phoneNumber);
    }
    
    if(isFilledDelivery){
        setIsFilledDelivery(isFilledDelivery);
    }
    
    if(giftRecipientDetails){
        setGiftRecipientDetails(giftRecipientDetails);
    }

    setSectionComplete(sectionComplete => ({ ...sectionComplete, deliveryDetails: true }))

}
   return (<>{ !loading ? <>

        {/* when basket call goes successfully then only the checkout page will show */}    

        {basket?.id ?
         <div class="container-wrapper two-columns" ref={errorContainerRef}>
            <section>
                <div className="container block-title">
                    <div className="item-container">
                        <div className="item-wrapper">  
                            <h1 className="block-header"> {t('payment.blockTitle') } </h1>
                        </div>
                    </div>
                </div>
               
                    {windowSize < 1000 &&

                    //  For mobile view: the basket data is going to show up on a modal
                        <> 
                       {showModal && <Modal isOpen={showModal} onClose={closeModal} buttonStyle={'close'}>
                           <Basket basket={basket} deliveryCountry={deliveryAddress.COUNTRY} loading={loading} isOnModal={showModal} />
                            </Modal>}

                            <div class="container">
                                <div className="item-container">
                                    <div className="item-wrapper"> <div className="two-columns-row">
                                        <h2 className="module-heading">{t('basket.title')} <span className="meta-info">({basket.lines.reduce((acc, line) => acc + line.quantity, 0)} items)</span> </h2>
                                        <button onClick={openModal} className='text-button'>View</button>
                                    </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    }

                <div className="container">
                    <div className="item-container">
                        <h2 className="module-heading">{t('checkout.usertitle')}</h2>
                    </div>

                    {/* User details block dependent on if it is guest flow or logged in user flow*/}

                    <div className="item-container">
                           <div className="item-wrapper">
                       {(isGuest || guestSession) ? 
                        props.reCaptchaKey && 
                        <GoogleReCaptchaProvider  reCaptchaKey={props.reCaptchaKey} scriptProps={{ async: true }}>
                        <GuestUser 
                        guestSession={guestSession}
                        basket={basket} 
                        adToken={adToken}
                        setAlreadyPurchased={setAlreadyPurchased}
                        originatingurl={getOriginatingUrl(basket, returnUrl)}
                        hasRecaptcha={props.reCaptchaKey!=="no_recaptcha"}
                        setGuestSession={setGuestSession}
                        sectionComplete={sectionComplete} 
                        setSectionComplete={setSectionComplete}
                        setPurchaseRestriction={setPurchaseRestriction}
           
                                       />
                                  
                      </GoogleReCaptchaProvider> : <> <LoginInfo />  </>}
                       </div>
                       </div>
        
                       {phoneConfiguration !== "Not shown" &&
                           <div className="item-container">
                               <div className="item-wrapper">
                                   <CapturePhone phoneConfiguration={phoneConfiguration}
                                   isPhoneNumberBlank={isPhoneNumberBlank } 
                                   setIsPhoneNumberBlank={setIsPhoneNumberBlank}
                                   isPhoneNumberInvalid={isPhoneNumberInvalid}
                                   setIsPhoneNumberInvalid={setIsPhoneNumberInvalid}
                                   phoneNumber={phoneNumber}
                                   setPhoneNumber={setPhoneNumber}
                                   ref={phoneRef}
                                />
                               </div>
                           </div>
                       }
                </div>
                
                    {/* Flow specific to worldpay-2nd step that has card details block */}

                    {showWorldPay ? <>

                        <div class={`container ${billingLoadingState ? `loading-state` : ""}`}>
                            <div className="two-columns-row">
                                 <div className="item-container">
                                     <h5 className="module-heading">{t('worldpayform.title')}</h5>
                                 </div>

                                 <a href="javascript:void(0)" onClick={handleOnBackButton} className="back-button flex-direction-row">
                                     <span className="back-icon"></span>
                                     <p>{t('worldpay.backlinktext')}</p>
                                </a>
                            </div>

                            {(paymentSelection) ? displayForm() : ""}
                            {paymentMethodErrors ? <GenericErrorBox errors={paymentMethodErrors} type="paymentMethodErrors" url={getOriginatingUrl(basket, returnUrl)} refreshUrl={window.location.href} /> : ""}

                        </div></> :

                    // Flow for other payment methods
              <> 
              
              {/* group discount flow */}
              
              {(groupDiscountNotValid.status==="true" && groupDiscountFlow==="true") && ((isGuest && guestSession) || !isGuest)  ?

                  <div className = "container"> 
                       
                       <div className = "item-container">
                           <MessageBox messageState="error">{ReactHtmlParser(groupDiscountNotValid?.errorText || "")}</MessageBox>
                       </div>
                     
                       <Button type="button" buttonSize="small" onClick={(e)=>{continueWithoutDiscount()}} >{t('button.continuetext')}</Button>
                    
                </div> : "" }
                
                <div class={`container ${billingLoadingState ? `loading-state` : ""}`}>
                {
                   ((alreadyPurchased.status==="true" || purchaseRestriction.status==="true") && !basket.allowgifting) ?  

                      <MessageBox messageState="error">{(alreadyPurchased?.text|| purchaseRestriction.text) && ReactHtmlParser(alreadyPurchased?.text||purchaseRestriction?.text||"")}</MessageBox>
                      : 
                      
                         ((isGuest && !guestSession && purchaseRestriction.status==="") || (groupDiscountNotValid.status=== "true" && groupDiscountFlow==="true")) ?       
                         
                           <h2 className="module-heading disabled">{t('delivery.title')}</h2>

                           : 
                        
                       ((isGuest && guestSession) || (!isGuest) && ((groupDiscountNotValid.status=== "true" && groupDiscountFlow==="false") || !groupDiscountFlow)) ?  <>

                       {/* if guest and guest session has started-****-not guest then delivery block should show */}

                        <div className="item-container">
                            <h2 className="module-heading">{t('delivery.title')}</h2>
                        </div>

                       <DeliveryDetails
                        IsFilled={IsFilledDelivery}
                        setIsFilled={setIsFilledDelivery}
                        setGiftRecipientDetails={setGiftRecipientDetails}
                        flags={flags}
                        setInitialFilledState={setInitialFilledState}
                        initialFilledState={initialFilledState}
                        showCompany={showCompany}
                        deliveryAddressStructure={deliveryAddressStructure}
                        setDeliveryAddressStructure={setDeliveryAddressStructure}
                        ref={deliveryRef}
                        fid={fid}
                        phoneNumber={phoneNumber}
                        optionalEmail={optionalEmail}
                        setOptionalEmail={setOptionalEmail}
                        loqateKey={loqateKey}
                        guestSession={guestSession}
                        setAlreadyPurchased={setAlreadyPurchased}
                        setPurchaseRestriction={setPurchaseRestriction}
                        checkForBasketRestrictions={checkForBasketRestrictions}
                        recipientDetails={recipientDetails}
                        getAddressStructure={getAddressStructure}
                        setRecipientDetails={setRecipientDetails}
                        selectedAddress={deliveryAddress}
                        setSelectedAddress={setDeliveryAddress}
                        selectedCompany={deliveryCompany}
                        setSelectedCompany={setDeliveryCompany}
                        sectionComplete={sectionComplete}
                        setSectionComplete={setSectionComplete}
                        deliveryCountryCode={deliveryCountryCode}
                        setDeliveryCountryCode={setDeliveryCountryCode}
                        companyProperties={companyProperties}
                        setcompanyProperties={setCompanyProperties}
                        basket={basket}
                        companyList={companyList}
                        loading={loading}
                        setBillingLoadingState={setBillingLoadingState}
                        setLoading={setLoading}
                        onVatNoChanged={onVatNoChanged} 
                        updateAndRefreshBasket={updateAndRefreshBasket}
                        invalidState = {isInvalidDelivery}
                        setInvalidState = {setIsInvalidDelivery}
                        sessionDeliveryDetails={sessionDeliveryDetails}
                        setBillingSectionLoading={setBillingSectionLoading}
                        latestDeliveryDetails={latestDeliveryDetails}
                        usingLatestDeliveryDetails={usingLatestDeliveryDetails}
                        setUsingLatestDeliveryDetails={setUsingLatestDeliveryDetails}
                        />
                      
                        
                        </>
                        
                    :"" }
                </div>
                
                  {basket.allowgifting && (alreadyPurchased.status==="true" || purchaseRestriction.status==="true") && sectionComplete.deliveryDetails ? 
                     <div class="container" >
                        <MessageBox messageState="error">{(alreadyPurchased?.text && ReactHtmlParser(alreadyPurchased?.text || ""))||(purchaseRestriction?.text && ReactHtmlParser(purchaseRestriction?.text || ""))}</MessageBox>
                     </div>

                  :""}

                    <div class="container" >
                        {/*needs revisiting*/}
                        {(((isGuest && guestSession && flags.isdeliverycountryrequired && !flags.isdeliverypostaladdressrequired && !basket.allowgifting) ||
                          (!isGuest && flags.isdeliverycountryrequired && !flags.isdeliverypostaladdressrequired && !basket.allowgifting) ||

                          (isGuest && guestSession && purchasingFor === "self" && flags.isdeliverycountryrequired && !flags.isdeliverypostaladdressrequired) ||
                          (isGuest && guestSession && sectionComplete?.deliveryDetails) || !isGuest && sectionComplete?.deliveryDetails  || (guestSession && purchasingFor === "gift" && sectionComplete.deliveryDetails)) 
                          || (isGuest && guestSession && sessionDeliveryDetails) 
                          || (!isGuest && sessionDeliveryDetails))  && (alreadyPurchased.status!=="true" && purchaseRestriction.status!=="true") && ((groupDiscountNotValid.status === "true" && groupDiscountFlow === "false") 
                          || !groupDiscountFlow) ? <>

                            <div className="item-container">
                                <h2 className="module-heading">{t('payment.title')}</h2>
                            </div>

                           
                           {/* Promo Code */}
                           {basket?.promotionapplicationmode !== "none" ?
                            <div className="item-container">
                               <div className="item-wrapper">
                                 
                                  <PromoCode promoCode={promoCode} setPromoCode={setPromoCode} fid={fid} setActionName={setActionName}  adToken ={adToken} purchasingFor={purchasingFor} deliveryCountryCode={deliveryCountryCode} variantIdForPromoCode={variantIdForPromoCode} updateAndRefreshBasket={updateAndRefreshBasket} basket={basket} />
                               </div>
                            </div>     
                            :""}
                            
                            {basket.offertypename==="free trial" ? 
                            
                            <div className="item-container">
                            <MessageBox messageState="info">{t('freetrial.message')}</MessageBox>
                            </div> 

                            : <>
                            <div className="item-container">
                                <h5 className="module-subheading">{t('billingdetails.title')}</h5>
                            </div>
                          
                            <BillingDetails
                                    IsFilled={IsFilledBilling}
                                    setIsFilled={setIsFilledBilling}
                                    IsFilledDelivery={IsFilledDelivery}
                                    ref={billingRef}
                                    fid={fid}
                                    basket={basket}
                                    setBasket={setBasket}
                                    vatDetails={vatDetails}
                                    deliveryAddressStructure={deliveryAddressStructure}
                                    loqateKey={loqateKey}
                                    showCompany={showCompany}
                                    sectionComplete={sectionComplete}
                                    setPaymentElementReload={setPaymentElementReload}
                                    setSectionComplete={setSectionComplete}
                                    selectedAddress={billingAddress}
                                    setSelectedAddress={setBillingAddress}
                                    deliveryAddress={deliveryAddress}
                                    setBasketErrors={setBasketErrors}
                                    setBillingCountryCode={setBillingCountryCode}
                                    setBillingsSameCheck={setBillingsSameCheck}
                                    purchasingFor={purchasingFor}
                                    deliveryCompany={deliveryCompany}
                                    selectedCompany={billingCompany}
                                    setSelectedCompany={setBillingCompany}
                                    deliveryCountryCode={deliveryCountryCode}
                                    companyProperties={companyProperties}
                                    setCompanyProperties={setCompanyProperties}
                                    flags={flags}
                                    companyList={companyList}
                                    updateAndRefreshBasket={updateAndRefreshBasket}
                                    loading={loading}i 
                                    onVatChecked={handleVatCheckedChange}
                                    onVatApplied={handleVatApplied}
                                    errorStates={errorStates} 
                                    setErrorStates={setErrorStates}
                                    invalidState = {isInvalidBilling}
                                    setInvalidState = {setIsInvalidBilling}
                                    billingSectionLoading={billingSectionLoading}
                                    setBillingSectionLoading={setBillingSectionLoading}
                                    latestBillingDetails={latestBillingDetails}
                                    usingLatestBillingDetails={usingLatestBillingDetails}
                                    setUsingLatestBillingDetails={setUsingLatestBillingDetails}
                                    usingLatestDeliveryDetails={usingLatestDeliveryDetails}
                                    />
                                    </>

                               }

                          <form method="Post" onSubmit={onSubmitPayment}>

                          {basket.offertypename==="free trial" ? "" :
                               <div className="item-container">
                                   <div className="border-seperator"></div>
                               </div>
                           }
                                    {/* Payment selection should only show up when there are more than 1 type */}
                                    
                                    {(basket?.paymentTypes?.length > 1) ?

                                        <div className="item-container">
                                            <PaymentSelection enableWallets={enableWallets}  billingSectionLoading={billingSectionLoading} walletMethods={walletMethods} paymentProvider={basket.defaultpaymentprovider} paymentTypes={basket?.paymentTypes} setErrorStates={setErrorStates} loading={loading} onChangePaymentSelection={onChangePaymentSelection} setPaymentSelection={setPaymentSelection}/>
                                            
                                            {errorStates.noPaymentSelected &&
                                                <span role="alert" id='payment-not-selected'><ErrorBox>{t('paymenttype.methodnotselected')}</ErrorBox></span>
                                            }

                                        </div> : ""}
                                     
                                     { /*Billing section loading state flow */}
                                     { billingSectionLoading ? ( (paymentSelection.paymenttype) ? <ShimmerInput/> : "" ) :
                                     
                                     (<>
                                     
                                     {/* Incase of worldpay nothing will show in Card details UI as that'll be done in the next step--**--when chosen anything else the normal flow will continue */}

                                     {(basket.defaultpaymentprovider=== "worldpay" && (paymentSelection?.paymenttype?.name === "Creditdebitcard" || paymentSelection?.paymenttype?.name === "Continuouscreditdebitcard")) ? "" :

                                       <div className={`${paymentSelection?.paymenttype?.name ? "item-container" : ""} `}>
                                         
                                            {paymentSelection? displayForm() : ""}
                                            {(paymentMethodErrors && paymentSelection) ? <GenericErrorBox errors={paymentMethodErrors} type="paymentMethodErrors" url={getOriginatingUrl(basket, returnUrl)} refreshUrl={window.location.href} /> : ""}
                                        </div>

                                        }   

                                   {/* Only to show when Continuous payment method is present */}

                                   {IsContinuousMethodPresent ? <AutorenewalTerms setIsAutoRenewalChecked={setIsAutoRenewalChecked} setErrorStates={setErrorStates} errorStates={errorStates} renewalText={props.brandingElement?.renewalTerms} showConsentCheckbox={showAutoRenewalConsentCheckbox} /> : ""}
                                   
                                   {/* Only to show when guest */}

                                   {((isGuest || guestSession)) ?  <MarketingPreferences branding={props.branding} isDpaQuestionTextBlank={isDpaQuestionTextBlank} setIsDpaQuestionTextBlank={setIsDpaQuestionTextBlank} originatingurl={getOriginatingUrl(basket, returnUrl)} setIsMarketingPreferencesChecked={setIsMarketingPreferencesChecked} setErrorStates={setErrorStates} errorStates={errorStates} /> : ""}
                                       <div className="item-container">
                                          <div className="meta">{ReactHtmlParser(termsText)} </div>
                                       </div>
                                 
                                   {windowSize < 1000 && basketSummaryForMobile()}


                               {errorStates.stripeCardIsInvalid ? <GenericErrorBox errors={errors} type="stripePaymentCardBrandError" cardTypes={paymentSelection?.paymenttype?.subpaymenttypes}/> : <GenericErrorBox errors={errors}/>}
                            

                            {/* button snippet */}
                                     
                                    {paymentSelection.paymenttype?.name === "Paypal" ?

                                    //button element specific to paypal

                                        (!isLoading && oAuthentication ?
                                            <Button type="submit" buttonSize="small">{paymentButtonText}</Button>
                                            : ((isLoading) ?
                                                <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{paymentButtonText}</Button>
                                                : <Button type="submit" buttonSize="small" isDisabled={`${isPaypal ? 'true' : 'false'}`} > {paymentButtonText}</Button>)
                                        )
                                        : (basket.defaultpaymentprovider === "worldpay" && (paymentSelection?.paymenttype?.name === "Creditdebitcard" || paymentSelection?.paymenttype?.name === "Continuouscreditdebitcard")) ?

                                            //button element specific to worldpay

                                            (!isLoading ? <Button type="submit" buttonSize="small">{continueToWorldpayButtonText}</Button>
                                                : <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{continueToWorldpayButtonText}</Button>)

                                            :  //button element for all other payment methods

                                            (!isLoading ? <Button type="submit" buttonSize="small">{paymentButtonText}</Button>
                                                : isLoading ? <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{paymentButtonText}</Button>
                                                    : "")
                                }
                                

                              </>)}
                                 
                          </form>
                          
                          
                    </> : <h2 className="module-heading disabled">{t('payment.title')}</h2>}
                </div>
                </>
                }
            </section>
         
         {windowSize > 1000 &&
                <section>
                    <div class="container summary">
                        <Basket basket={basket} deliveryCountry={deliveryAddress.COUNTRY} loading={loading} />
                    </div>
                </section>
            }

            
            <LogWebActivity promoCode={promoCode} actionName={actionName} isGuest={isGuest} guestSession={guestSession} setCheckoutStartedFired={setCheckoutStartedFired}/>
        </div>
        : <div className="container-wrapper one-column">

           {/* when basket call errs */}
           <GenericErrorBox errors={basketErrors} url={getOriginatingUrl(basket, returnUrl)}  refreshUrl={window.location.href} startAgainUrl={getOriginatingUrl(basket, returnUrl)} thankyouPageUrl={getThankyouPageUrl()}/>
         
         </div>}
    </>
    : <Loading loading={loading} />}
        </>
        
    )

}